// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"oVynM","text-wrapper":"_1ezU-","cta-wrapper":"_3P0Ae","sub-btn":"_1DV1x"};